// extracted by mini-css-extract-plugin
export var grid = "_1c-0";
export var span1 = "_1c-2";
export var span10 = "_1c-b";
export var span10L = "_1c-z";
export var span10M = "_1c-n";
export var span10Xl = "_1c-1b";
export var span11 = "_1c-c";
export var span11L = "_1c-10";
export var span11M = "_1c-o";
export var span11Xl = "_1c-1c";
export var span12 = "_1c-d";
export var span12L = "_1c-11";
export var span12M = "_1c-p";
export var span12Xl = "_1c-1d";
export var span1L = "_1c-q";
export var span1M = "_1c-e";
export var span1Xl = "_1c-12";
export var span2 = "_1c-3";
export var span2L = "_1c-r";
export var span2M = "_1c-f";
export var span2Xl = "_1c-13";
export var span3 = "_1c-4";
export var span3L = "_1c-s";
export var span3M = "_1c-g";
export var span3Xl = "_1c-14";
export var span4 = "_1c-5";
export var span4L = "_1c-t";
export var span4M = "_1c-h";
export var span4Xl = "_1c-15";
export var span5 = "_1c-6";
export var span5L = "_1c-u";
export var span5M = "_1c-i";
export var span5Xl = "_1c-16";
export var span6 = "_1c-7";
export var span6L = "_1c-v";
export var span6M = "_1c-j";
export var span6Xl = "_1c-17";
export var span7 = "_1c-8";
export var span7L = "_1c-w";
export var span7M = "_1c-k";
export var span7Xl = "_1c-18";
export var span8 = "_1c-9";
export var span8L = "_1c-x";
export var span8M = "_1c-l";
export var span8Xl = "_1c-19";
export var span9 = "_1c-a";
export var span9L = "_1c-y";
export var span9M = "_1c-m";
export var span9Xl = "_1c-1a";
export var stretch = "_1c-1";